export interface DesignStyle {
  id: string
  label: string
  description: string
  emoji: string
  cssVars: Record<string, string>
  googleFonts: string[]
  previewBg: string
  previewAccent: string
}

export const DESIGN_STYLES: DesignStyle[] = [
  {
    id: 'minimalism',
    label: 'Минимализм',
    description: 'Чистые линии, много белого пространства, тонкие шрифты',
    emoji: '◻',
    googleFonts: ['DM+Sans:wght@300;400;500;600'],
    previewBg: '#fafafa',
    previewAccent: '#111111',
    cssVars: {
      '--bst-r': '4px',
      '--bst-shadow': 'none',
      '--bst-border': '1px solid #e5e5e5',
      '--bst-font-heading': '"DM Sans", sans-serif',
      '--bst-font-body': '"DM Sans", sans-serif',
      '--bst-accent': '#111111',
      '--bst-btn-bg': '#111111',
      '--bst-btn-color': '#ffffff',
      '--bst-card-bg': '#fafafa',
      '--bst-heading-weight': '300',
      '--bst-letter-spacing': '0.02em',
      '--bst-page-bg': '#fafafa',
      '--bst-heading-color': '#111111',
      '--bst-section-light-bg': '#f4f4f4',
    },
  },
  {
    id: 'maximalism',
    label: 'Максимализм',
    description: 'Яркие цвета, узоры, богатые текстуры, высокая насыщенность',
    emoji: '✦',
    googleFonts: ['Playfair+Display:ital,wght@0,700;1,700', 'Lora:ital@0;1'],
    previewBg: '#fdf4e7',
    previewAccent: '#c0392b',
    cssVars: {
      '--bst-r': '0px',
      '--bst-shadow': '6px 6px 0 #c0392b',
      '--bst-border': '3px solid #2c3e50',
      '--bst-font-heading': '"Playfair Display", serif',
      '--bst-font-body': '"Lora", serif',
      '--bst-accent': '#c0392b',
      '--bst-btn-bg': '#c0392b',
      '--bst-btn-color': '#fdf4e7',
      '--bst-card-bg': '#fdf4e7',
      '--bst-heading-weight': '700',
      '--bst-letter-spacing': '-0.01em',
      '--bst-page-bg': '#fdf4e7',
      '--bst-heading-color': '#2c3e50',
      '--bst-section-light-bg': '#f5e6c8',
    },
  },
  {
    id: 'brutalism',
    label: 'Брутализм',
    description: 'Жирные границы, резкие тени, сырой и дерзкий стиль',
    emoji: '◼',
    googleFonts: ['Space+Grotesk:wght@700'],
    previewBg: '#ffffff',
    previewAccent: '#000000',
    cssVars: {
      '--bst-r': '0px',
      '--bst-shadow': '5px 5px 0 #000000',
      '--bst-border': '3px solid #000000',
      '--bst-font-heading': '"Space Grotesk", "Helvetica Neue", sans-serif',
      '--bst-font-body': '"Helvetica Neue", Arial, sans-serif',
      '--bst-accent': '#ff3333',
      '--bst-btn-bg': '#000000',
      '--bst-btn-color': '#ffffff',
      '--bst-card-bg': '#ffff00',
      '--bst-heading-weight': '700',
      '--bst-letter-spacing': '-0.02em',
      '--bst-page-bg': '#ffffff',
      '--bst-heading-color': '#000000',
      '--bst-section-light-bg': '#f0f0f0',
    },
  },
  {
    id: 'swiss',
    label: 'Швейцарский стиль',
    description: 'Сетка, симметрия, IBM Plex Sans, строгая типографика',
    emoji: '⊞',
    googleFonts: ['IBM+Plex+Sans:wght@300;400;600', 'IBM+Plex+Mono'],
    previewBg: '#f5f5f5',
    previewAccent: '#e63946',
    cssVars: {
      '--bst-r': '0px',
      '--bst-shadow': 'none',
      '--bst-border': '1px solid #000000',
      '--bst-font-heading': '"IBM Plex Sans", sans-serif',
      '--bst-font-body': '"IBM Plex Sans", sans-serif',
      '--bst-accent': '#e63946',
      '--bst-btn-bg': '#000000',
      '--bst-btn-color': '#ffffff',
      '--bst-card-bg': '#ffffff',
      '--bst-heading-weight': '600',
      '--bst-letter-spacing': '0em',
      '--bst-page-bg': '#f5f5f5',
      '--bst-heading-color': '#000000',
      '--bst-section-light-bg': '#ebebeb',
    },
  },
  {
    id: 'constructivism',
    label: 'Конструктивизм',
    description: 'Геометрия, красный и чёрный, мощные шрифты Russo One',
    emoji: '◆',
    googleFonts: ['Russo+One', 'Montserrat:wght@400;700'],
    previewBg: '#f5f5f0',
    previewAccent: '#d62828',
    cssVars: {
      '--bst-r': '0px',
      '--bst-shadow': '4px 4px 0 #d62828',
      '--bst-border': '2px solid #111111',
      '--bst-font-heading': '"Russo One", sans-serif',
      '--bst-font-body': '"Montserrat", sans-serif',
      '--bst-accent': '#d62828',
      '--bst-btn-bg': '#d62828',
      '--bst-btn-color': '#ffffff',
      '--bst-card-bg': '#f5f5f0',
      '--bst-heading-weight': '400',
      '--bst-letter-spacing': '0.04em',
      '--bst-page-bg': '#f5f5f0',
      '--bst-heading-color': '#111111',
      '--bst-section-light-bg': '#eeeee9',
    },
  },
  {
    id: 'handdrawn',
    label: 'Рисованный стиль',
    description: 'Caveat, неровные края, уютный почерковый вид',
    emoji: '✏',
    googleFonts: ['Caveat:wght@400;700', 'Nunito:wght@400;600'],
    previewBg: '#fffef5',
    previewAccent: '#2a9d8f',
    cssVars: {
      '--bst-r': '12px 4px 16px 6px',
      '--bst-shadow': '3px 3px 0 rgba(0,0,0,0.15)',
      '--bst-border': '2px solid rgba(0,0,0,0.6)',
      '--bst-font-heading': '"Caveat", cursive',
      '--bst-font-body': '"Nunito", sans-serif',
      '--bst-accent': '#2a9d8f',
      '--bst-btn-bg': '#2a9d8f',
      '--bst-btn-color': '#ffffff',
      '--bst-card-bg': '#fffef5',
      '--bst-heading-weight': '700',
      '--bst-letter-spacing': '0.01em',
      '--bst-page-bg': '#fffef5',
      '--bst-heading-color': '#3d3016',
      '--bst-section-light-bg': '#f8f6e8',
    },
  },
  {
    id: 'retro',
    label: 'Ретро и Y2K',
    description: 'Неоновые цвета, Orbitron, dark-фон, cyberpunk-эстетика',
    emoji: '⟁',
    googleFonts: ['Orbitron:wght@400;700;900', 'Share+Tech+Mono'],
    previewBg: '#0a0a1a',
    previewAccent: '#00ffcc',
    cssVars: {
      '--bst-r': '2px',
      '--bst-shadow': '0 0 16px rgba(0,255,204,0.5)',
      '--bst-border': '1px solid rgba(0,255,204,0.4)',
      '--bst-font-heading': '"Orbitron", monospace',
      '--bst-font-body': '"Share Tech Mono", monospace',
      '--bst-accent': '#00ffcc',
      '--bst-btn-bg': 'transparent',
      '--bst-btn-color': '#00ffcc',
      '--bst-card-bg': '#111133',
      '--bst-heading-weight': '700',
      '--bst-letter-spacing': '0.08em',
      '--bst-page-bg': '#0a0a1a',
      '--bst-heading-color': '#00ffcc',
      '--bst-section-light-bg': '#0d0d25',
    },
  },
  {
    id: 'bento',
    label: 'Бенто',
    description: 'Карточки, скругления 20px+, мягкие тени, сбалансированная сетка',
    emoji: '⊟',
    googleFonts: ['Plus+Jakarta+Sans:wght@400;500;600;700'],
    previewBg: '#f3f4f6',
    previewAccent: '#6366f1',
    cssVars: {
      '--bst-r': '20px',
      '--bst-shadow': '0 4px 24px rgba(0,0,0,0.08)',
      '--bst-border': '1px solid rgba(0,0,0,0.06)',
      '--bst-font-heading': '"Plus Jakarta Sans", sans-serif',
      '--bst-font-body': '"Plus Jakarta Sans", sans-serif',
      '--bst-accent': '#6366f1',
      '--bst-btn-bg': '#6366f1',
      '--bst-btn-color': '#ffffff',
      '--bst-card-bg': '#ffffff',
      '--bst-heading-weight': '700',
      '--bst-letter-spacing': '-0.01em',
      '--bst-page-bg': '#f3f4f6',
      '--bst-heading-color': '#1e1b4b',
      '--bst-section-light-bg': '#e9eaed',
    },
  },
  {
    id: 'flat',
    label: 'Плоский дизайн',
    description: 'Без теней, насыщенные однотонные цвета, чёткие формы',
    emoji: '▣',
    googleFonts: ['Nunito+Sans:wght@400;600;700'],
    previewBg: '#ffffff',
    previewAccent: '#e74c3c',
    cssVars: {
      '--bst-r': '8px',
      '--bst-shadow': 'none',
      '--bst-border': 'none',
      '--bst-font-heading': '"Nunito Sans", sans-serif',
      '--bst-font-body': '"Nunito Sans", sans-serif',
      '--bst-accent': '#e74c3c',
      '--bst-btn-bg': '#e74c3c',
      '--bst-btn-color': '#ffffff',
      '--bst-card-bg': '#fef2f2',
      '--bst-heading-weight': '700',
      '--bst-letter-spacing': '0em',
      '--bst-page-bg': '#ffffff',
      '--bst-heading-color': '#1a1a1a',
      '--bst-section-light-bg': '#fff5f5',
    },
  },
]

export const DESIGN_STYLE_MAP = Object.fromEntries(DESIGN_STYLES.map(s => [s.id, s]))
